<app-loading [show]="!renderedQuestions && !error"></app-loading>
<ng-container *ngFor="let category of categories; let i = index">
  <app-poll
    *ngIf="currentCategory[i] && renderedQuestions"
    [stepNumber]="i + 1"
    [totalSteps]="categories.length"
    [progressValue]="progressValue"
    [categoryQuestions]="currentCategoryQuestions"
    (buttonClick)="handleButtonClick($event)"
  >
  </app-poll>
</ng-container>

<ng-container *ngIf="error">
  <app-custom-error message="Ha ocurrido un error al obtener la encuesta">
  </app-custom-error>
</ng-container>
